var map = {
	"./alert.svg": 12387,
	"./alert_reject.svg": 60371,
	"./alert_success.svg": 20991,
	"./arrow-right.svg": 95155,
	"./aspect_ratio.svg": 70243,
	"./book.svg": 31144,
	"./calendar.svg": 33181,
	"./check-circle.svg": 96434,
	"./checkbox.svg": 80776,
	"./chevron-down.svg": 63313,
	"./chevron-left.svg": 40042,
	"./chevron-right.svg": 59777,
	"./chevron-up-24.svg": 11961,
	"./chevron-up.svg": 89390,
	"./circle-slash.svg": 67839,
	"./circle_plus.svg": 12098,
	"./circle_x.svg": 30682,
	"./delete_grey.svg": 27256,
	"./divider.svg": 97778,
	"./download.svg": 19395,
	"./download_grey.svg": 99063,
	"./edit.svg": 95547,
	"./edit_simple.svg": 23256,
	"./email.svg": 82533,
	"./eye.svg": 51398,
	"./file_add.svg": 79885,
	"./file_grey.svg": 58733,
	"./filter.svg": 2101,
	"./flag.svg": 77013,
	"./flags/de.svg": 67506,
	"./flags/en.svg": 97882,
	"./flags/es.svg": 27631,
	"./flags/fr.svg": 3543,
	"./flags/la.svg": 78678,
	"./flags/ru.svg": 98460,
	"./flags/uk.svg": 31303,
	"./folder_add.svg": 98495,
	"./heart_fill.svg": 80599,
	"./home.svg": 83130,
	"./home_icons/documents.svg": 48334,
	"./home_icons/museum-fund.svg": 92592,
	"./home_icons/museums.svg": 2611,
	"./home_icons/references.svg": 83434,
	"./home_icons/thesaurus.svg": 24920,
	"./horizontal-align-left.svg": 24151,
	"./horizontal-align-right.svg": 22098,
	"./images/contract.svg": 28810,
	"./images/contract_rect.svg": 44111,
	"./images/desktop.svg": 11420,
	"./images/desktop_placeholder.svg": 53682,
	"./images/docs.svg": 87345,
	"./images/document_folded.svg": 636,
	"./images/edit.svg": 7304,
	"./images/enter.svg": 55478,
	"./images/feedback.svg": 4305,
	"./images/home.svg": 99881,
	"./images/image_big.svg": 27828,
	"./images/numbers.svg": 74742,
	"./images/plus_big.svg": 26487,
	"./images/policy.svg": 69042,
	"./images/sponsor.svg": 97582,
	"./images/ua_trident_v2.svg": 69578,
	"./info.svg": 92591,
	"./kebab-horizontal.svg": 21323,
	"./key.svg": 71420,
	"./modal_delete.svg": 86816,
	"./plus.svg": 15007,
	"./plus_square.svg": 94135,
	"./reply.svg": 30181,
	"./reset.svg": 95408,
	"./search_grey.svg": 13831,
	"./settings.svg": 79416,
	"./sync.svg": 37062,
	"./table_inferiority.svg": 89406,
	"./table_success.svg": 41425,
	"./triangle-down.svg": 66516,
	"./triangle_down_grey.svg": 16228,
	"./upload.svg": 92716,
	"./user.svg": 88670,
	"./view_three_columns.svg": 27277,
	"./x.svg": 78981,
	"./x_black.svg": 12665,
	"./x_grey.svg": 56689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57477;